import React from 'react';
import { Formik } from 'formik';
import { TextField, Button, Theme } from '@mui/material';
import { ChangePasswordForm, HttpStatuses } from '../types';
import { useTranslation } from 'react-i18next';
import makeStyles from '@mui/styles/makeStyles';
import setuppassword from '../lib/services/setuppassword';

const useStyles = makeStyles((theme: Theme) => ({
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1)
  },
  submit: {
    margin: theme.spacing(3, 0, 2)
  }
}));

interface Props {
  token: string;
  handleSuccess: () => void;
  handleFailure: () => void;
}

/**
 * Change Password Form
 * @param props
 */
export const PasswordSetupForm: React.FC<Props> = ({
  token,
  handleSuccess,
  handleFailure
}) => {
  const classes = useStyles();
  const { t } = useTranslation('translation');
  return (
    <Formik
      initialValues={{} as ChangePasswordForm}
      onSubmit={async values => {
        const response = await setuppassword(token, {
          password: values.password
        });
        if (response.status === HttpStatuses.success) {
          handleSuccess();
        } else {
          handleFailure();
        }
      }}
      validate={values => {
        let errors: { [key: string]: any } = {};
        if (!values.password) {
          errors.password = t('enterValue');
        }
        if (values.password.length < 8) {
          errors.password = t('passwordLength');
        }
        if (!values.confirmedPassword) {
          errors.confirmedPassword = t('enterValue');
        }
        if (values.password && values.confirmedPassword) {
          if (values.password !== values.confirmedPassword) {
            errors.confirmedPassword = t('errorConfirmedPassword');
          }
        }
        return errors;
      }}
    >
      {({
        handleSubmit,
        handleChange,
        handleBlur,
        errors,
        isValid,
        isSubmitting
      }) => (
        <form onSubmit={handleSubmit} className={classes.form} noValidate>
          <TextField
            variant="standard"
            margin="normal"
            required
            fullWidth
            label={t('password')}
            name="password"
            type="password"
            autoFocus
            onChange={handleChange}
            onBlur={handleBlur}
            error={!!errors.password}
            helperText={errors.password}
          />
          <TextField
            variant="standard"
            margin="normal"
            required
            fullWidth
            label={t('confirmedPassword')}
            name="confirmedPassword"
            type="password"
            onChange={handleChange}
            onBlur={handleBlur}
            error={!!errors.confirmedPassword}
            helperText={errors.confirmedPassword}
          />
          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            className={classes.submit}
            disabled={isSubmitting || !isValid}
          >
            {t('setupPassword')}
          </Button>
        </form>
      )}
    </Formik>
  );
};
